import React from "react";

const DropboxIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.49981 8.08368L10.0004 5.21683L14.5002 8.08368L10.0004 10.9505L5.49981 8.08368ZM5.49981 8.08368L1 10.9505L5.49981 13.8174L10.0004 10.9505L14.5002 13.8174L19 10.9505L14.5002 8.08368L19 5.21683L14.5002 2.34998L10.0004 5.21683L5.49981 2.34998L1 5.21683L5.49981 8.08368ZM10.0004 11.9061L14.5002 14.773L10.0004 17.6398L5.49981 14.773L10.0004 11.9061Z",
  fill: "#0061FF"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DropboxIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;